import { AxiosResponse } from 'axios';
import { END_POINT } from '../end-point';
import { getCookie } from '../../lib/cookie';
import { decrypt } from '../../lib/utils/crypto';
import { TMeResponse, TRequestLoginParams, TResponseLogin, TResponseMeData } from '../../types/api';
import { httpService } from '../util/axiosRequests';
import { CommonResponse } from 'types/axios';
import { axiosInstance } from 'apis/axiosConfig';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const authAPI = {
  tokenRefreshAPI: async (data: any) => {
    try {
      const response = await httpService.post<TResponseLogin>(END_POINT.authController.postTokenRefresh, data, { withCredentials: true });
      return response;
    } catch (error) {
      // console.error('tokenRefreshAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 로그인
  loginAPI: async (data: TRequestLoginParams) => {
    try {
      const response = await httpService.post<TResponseLogin>(END_POINT.authController.postLogin, data, { withCredentials: true });
      return response;
    } catch (error) {
      // console.error('loginAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 내 정보 조회
  getMeAPI: async () => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await axiosInstance.get<TMeResponse>(END_POINT.authController.getMe, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      return response.data; // 응답의 데이터 return
      // 응답의 데이터  return
    } catch (error) {
      // console.error('getMeAPI 호출 에러:', error);
      console.error(error);
      throw error; //에러
    }
  },

  // 아이디 중복 확인
  checkUsernameAPI: async (username: string) => {
    try {
      const response = await axiosInstance.get<TMeResponse>(END_POINT.authController.getCheckUsername, {
        params: { username } // 쿼리 파라미터 전달
      });

      return response.data; // 응답의 데이터 return
    } catch (error) {
      // console.error('checkUsernameAPI 호출 에러:', error);
      console.error(error);
      throw error; //에러
    }
  },
  //회원가입
  postSignupAPI: async (data: any) => {
    try {
      const response = await axiosInstance.post<TMeResponse>(END_POINT.authController.postSignup, data, { withCredentials: true });

      return response;
    } catch (error) {
      // console.error('signupAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 아이디찾기API
  postFindUsernameAPI: async (data: any) => {
    try {
      const response = await axiosInstance.post<any>(END_POINT.authController.postFindUsername, data, { withCredentials: true });
      return response;
    } catch (error) {
      // console.error('아이디찾기API 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 내 정보 변경
  putMeAPI: async (data: { currentPassword: string; newPassword: string; name: string; birth: string; companyName: string }) => {
    try {
      const accessToken = getAccessTokenFromCookies();

      const response = await axiosInstance.put<any>(
        END_POINT.authController.getMe,
        data, // 수정된 data 객체를 body에 포함
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );

      return response.data; // 응답 데이터 반환
    } catch (error) {
      // console.error('putMeAPI 호출 에러:', error);
      console.error(error);
      throw error; // 에러 발생 시 throw
    }
  },
  // 회원탈퇴
  deleteWithdrawAPI: async () => {
    try {
      const accessToken = getAccessTokenFromCookies();
      const response = await axiosInstance.delete<any>(END_POINT.authController.deleteWithdraw, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data; // 응답 데이터 반환
    } catch (error) {
      // console.error('deleteWithdrawAPI 호출 에러:', error);
      console.error(error);
      throw error; // 에러 발생 시 throw
    }
  },
  // 사용자 정지
  putUserIdAbortAPI: async (data: any, userId: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.put<any>(END_POINT.authController.putUserIdAbort(userId), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });

      return response;
    } catch (error) {
      // console.error('putUserIdAbortAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 사용자 활성화
  putUserIdActiveAPI: async (data: any, userId: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.put<any>(END_POINT.authController.putUserIdActive(userId), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });

      return response;
    } catch (error) {
      // console.error('putUserIdActiveAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 사용자 비밀번호 초기화
  putUserNameInitPasswordAPI: async (username: string) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.put<any>(
        END_POINT.authController.putUserNameInitPassword(username),
        {},
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
          }
        }
      );

      return response;
    } catch (error) {
      // console.error('putUserIdInitPasswordAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  }
};

export const {
  tokenRefreshAPI,
  loginAPI,
  getMeAPI,
  checkUsernameAPI,
  postSignupAPI,
  postFindUsernameAPI,
  putMeAPI,
  deleteWithdrawAPI,
  putUserIdAbortAPI,
  putUserIdActiveAPI,
  putUserNameInitPasswordAPI
} = authAPI;
